/**
 * Memo Configuration Types
 *
 * Configurable memo pricing and terms
 */
import { RoleLevel } from './rbacImproved';
/**
 * Default role-based markup configuration
 * Can be overridden in database or admin settings
 */
export const DEFAULT_ROLE_MARKUPS = [
    {
        roleLevel: RoleLevel.BASIC_DEALER,
        roleName: 'BASIC_DEALER',
        markupPercent: 5,
        enabled: true
    },
    {
        roleLevel: RoleLevel.VERIFIED_DEALER,
        roleName: 'VERIFIED_DEALER',
        markupPercent: 0,
        enabled: true
    },
    {
        roleLevel: RoleLevel.SENIOR_DEALER,
        roleName: 'SENIOR_DEALER',
        markupPercent: 0,
        enabled: true
    },
    {
        roleLevel: RoleLevel.SALES_MANAGER,
        roleName: 'SALES_MANAGER',
        markupPercent: 0,
        enabled: true
    },
    {
        roleLevel: RoleLevel.PLATFORM_ADMIN,
        roleName: 'PLATFORM_ADMIN',
        markupPercent: 0,
        enabled: true
    },
    {
        roleLevel: RoleLevel.SUPER_ADMIN,
        roleName: 'SUPER_ADMIN',
        markupPercent: 0,
        enabled: true
    }
];
/**
 * Default memo terms by role
 */
export const DEFAULT_MEMO_TERMS = {
    [RoleLevel.SUSPENDED]: {
        minDurationDays: 0,
        maxDurationDays: 0,
        defaultDurationDays: 0,
        requiresApproval: true,
        requiresCreditCheck: true,
        requiresInsurance: true
    },
    [RoleLevel.GUEST]: {
        minDurationDays: 0,
        maxDurationDays: 0,
        defaultDurationDays: 0,
        requiresApproval: true,
        requiresCreditCheck: true,
        requiresInsurance: true
    },
    [RoleLevel.DEALER_APPLICANT]: {
        minDurationDays: 0,
        maxDurationDays: 0,
        defaultDurationDays: 0,
        requiresApproval: true,
        requiresCreditCheck: true,
        requiresInsurance: true
    },
    [RoleLevel.BASIC_DEALER]: {
        minDurationDays: 7,
        maxDurationDays: 14,
        defaultDurationDays: 7,
        requiresApproval: true,
        requiresCreditCheck: true,
        requiresInsurance: true
    },
    [RoleLevel.VERIFIED_DEALER]: {
        minDurationDays: 7,
        maxDurationDays: 21,
        defaultDurationDays: 14,
        requiresApproval: true,
        requiresCreditCheck: false,
        requiresInsurance: true
    },
    [RoleLevel.SENIOR_DEALER]: {
        minDurationDays: 7,
        maxDurationDays: 30,
        defaultDurationDays: 14,
        requiresApproval: false, // Auto-approved
        requiresCreditCheck: false,
        requiresInsurance: true
    },
    [RoleLevel.SALES_MANAGER]: {
        minDurationDays: 1,
        maxDurationDays: 90,
        defaultDurationDays: 14,
        requiresApproval: false,
        requiresCreditCheck: false,
        requiresInsurance: false
    },
    [RoleLevel.REGION_ADMIN]: {
        minDurationDays: 1,
        maxDurationDays: 90,
        defaultDurationDays: 14,
        requiresApproval: false,
        requiresCreditCheck: false,
        requiresInsurance: false
    },
    [RoleLevel.PLATFORM_ADMIN]: {
        minDurationDays: 1,
        maxDurationDays: 90,
        defaultDurationDays: 14,
        requiresApproval: false,
        requiresCreditCheck: false,
        requiresInsurance: false
    },
    [RoleLevel.SUPER_ADMIN]: {
        minDurationDays: 1,
        maxDurationDays: 90,
        defaultDurationDays: 14,
        requiresApproval: false,
        requiresCreditCheck: false,
        requiresInsurance: false
    }
};
